angular.module('PatientApp').controller('EstimateCtrl', function($q, $scope, $rootScope, $state, $log, $interval, Compass, $filter, EstimatesService, AuthService){

    var _token = $state.params.token,
        // all of the entry points extending from verify
        // need the bill to be linked asap. So this method
        // is used to make sure that happens from these touch points
        getUserAndLink = function(estimate){
            var deferred = $q.defer();

            AuthService.requireAuthedUser().then(function(){
                // flow for if we link estimate to the patient user beforehand
                EstimatesService.verifyLinked(estimate).then(function(resp) {
                    if (!resp.estimateId) {
                        deferred.reject('Estimate is not linked to user');
                    } else {
                        deferred.resolve(resp.estimateId);
                    }
                });

            }).catch(function(message){
                $log.error(message);
                deferred.reject(message);
            });

            return deferred.promise;
        };

    if (!_token) {
        $state.go('app.default');
    }

    $scope.getEstimate = function() {
        EstimatesService.find(_token).then(function(resp) {
            $scope.estimate = resp;
        }).catch(function() {
            Compass.capture.failure('estimate', 'token', '');
            $state.go('app.default');
        });
    };

    $scope.makePayment = function(){
        getUserAndLink($scope.estimate).then(function() {
            $state.go('app.payment.start', {estimateId:$scope.estimate.id});
        });
    };

    $scope.viewEstimateDetails = function(){
        getUserAndLink($scope.estimate).then(function(estimateId) {
            $state.go('app.dashboard.provider.details.estimate-details', {id: $scope.estimate.providerDetails.id, estimateId: estimateId});
        });
    };

    $scope.messageProvider = function() {
        getUserAndLink($scope.estimate).then(function(estimateId){
            $rootScope.$emit('message:compose', { estimateId: estimateId, reason: 11 });
        });
    };

    $scope.getEstimate();

});
